import Card from "react-bootstrap/Card"
import CancelAccount from "../CancelAccount/CancelAccount"
import react, {useState} from "react";
import classes from "./Settings.module.css"

function ChainSettings({setTriggerReload}) {
    const [showCancelAccount, setShowCancelAccount] = useState(false);

    return (
        <>
            <Card  className={`${classes.cardWidth} mb-5 shadow`}>
                <Card.Body>
                    <a role="button" className="text-primary" onClick={()=>setShowCancelAccount(true)}> Need to Cancel? </a>
                </Card.Body>
            </Card>
            <CancelAccount showCancelAccount={showCancelAccount} setShowCancelAccount={setShowCancelAccount} setTriggerReload={setTriggerReload}/>
        </>
    )
}

export default ChainSettings